// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* games/minesweeper/Minesweeper.css */

.ms-board {
  position: fixed;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 98%;
  max-width: 496px;
  background: #1a1a1a;
  border: 4px solid #2c3e50; /* Стиль корпуса как в Тедрисе */
  border-radius: 12px;
  padding: 15px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.9);
  display: flex;
  flex-direction: column;
  z-index: 6000;
  font-family: 'Courier New', monospace;
  box-sizing: border-box;
}

/* Шапка с тактическими данными */
.ms-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 8px 12px;
  background: #000;
  border: 1px solid #334155;
  border-radius: 4px;
  box-shadow: inset 0 2px 5px rgba(0,0,0,0.8);
}

.ms-stat {
  color: #fbbf24; /* Твой фирменный золотой */
  font-weight: bold;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
}

.ms-stat.danger { color: #ef4444; }

/* СЕТКА - Исправляем схлопывание */
.ms-grid {
  display: grid;
  gap: 4px;
  background: #0e0e0e; /* Фон колодца */
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #334155;
  box-shadow: inset 0 0 20px rgba(0,0,0,1);
  width: 100%; /* Занимаем всю ширину родителя */
  box-sizing: border-box;
  /* aspect-ratio настраивается в JS динамически */
}

.ms-cell {
  width: 100%;
  background: #262626;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* УВЕЛИЧИВАЕМ ШРИФТ ЦИФР */
  font-size: 22px;
  font-weight: 900;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: all 0.1s;
  aspect-ratio: 1/1; /* Квадратные ячейки */
  box-shadow:
    inset 1px 1px 0 rgba(255,255,255,0.05),
    0 2px 4px rgba(0,0,0,0.5);
  position: relative;
  /* Убираем системное меню на мобилках для лонг-пресса */
  -webkit-touch-callout: none;
}

.ms-cell:active:not(.revealed) {
  transform: scale(0.9);
  background: #444;
}

.ms-cell.revealed {
  background: #111;
  box-shadow: inset 0 2px 8px rgba(0,0,0,0.8);
  cursor: default;
}

.ms-cell.flagged {
  background: #1e293b;
}

/* ЦВЕТ ФЛАГА - ТЕПЕРЬ КРАСНЫЙ */
.ms-flag-icon {
  color: #ef4444; /* Насыщенный красный */
  filter: drop-shadow(0 0 3px rgba(239, 68, 68, 0.5));
  font-size: 16px;
}

/* Цвета цифр делаем еще сочнее */
.n-1 { color: #3b82f6; text-shadow: 0 0 2px rgba(59, 130, 246, 0.3); }
.n-2 { color: #22c55e; text-shadow: 0 0 2px rgba(34, 197, 94, 0.3); }
.n-3 { color: #ef4444; text-shadow: 0 0 2px rgba(239, 68, 68, 0.3); }
.n-4 { color: #a855f7; }
.n-5 { color: #f59e0b; }
.n-0 { opacity: 0; } /* Пустые клетки чистые */

.ms-mine {
  font-size: 18px;
  color: #ff3333;
  filter: drop-shadow(0 0 5px #ff0000);
  animation: ms-danger-pulse 1s infinite alternate;
}

@keyframes ms-danger-pulse {
  from { transform: scale(0.9); opacity: 0.8; }
  to { transform: scale(1.1); opacity: 1; }
}

/* ПАНЕЛЬ УПРАВЛЕНИЯ */
.ms-toggle-bar {
  display: flex;
  gap: 10px;
  margin-top: 15px;
}

.ms-mode-btn {
  flex: 1 1;
  height: 55px; /* Чуть выше */
  border: none;
  border-radius: 10px;
  background: #334155;
  color: #94a3b8;
  /* ШРИФТ КРУПНЕЕ */
  font-size: 18px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: inherit;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.2s;
  box-shadow: 0 4px 0 #1e293b;
}

.ms-mode-btn svg {
  font-size: 20px; /* Иконки тоже чуть крупнее */
}

.ms-mode-btn.active {
  background: #fbbf24;
  color: #0f172a;
  box-shadow: 0 4px 0 #b45309;
  transform: translateY(0);
}

.ms-mode-btn:active {
  transform: translateY(2px);
  box-shadow: 0 2px 0 #1e293b;
}

.ms-mode-btn.active:active {
  box-shadow: 0 2px 0 #b45309;
}

/* Эффект накопления заряда при длинном нажатии */
@keyframes cell-press-grow {
  from { transform: scale(1); }
  to { transform: scale(1.15); background: #444; }
}

.ms-cell.pressing:not(.revealed) {
  animation: cell-press-grow 0.5s forwards;
  z-index: 10;
}

/* УЛУЧШЕННЫЙ ЭКРАН РЕЗУЛЬТАТОВ */

.ms-overlay-bg {
  background: #1a1a1a1c;
}

/* 1. Названия параметров (ОЧКИ, ЗВАНИЕ) */
.ms-report-stat-label {
  font-size: 14px;
  font-weight: 900;
  text-transform: uppercase;
  color: #666;
  letter-spacing: 1px;

}

/* 2. Значения параметров */
.ms-report-stat-value {
  font-size: 26px; /* Значительно крупнее */
  font-weight: 900;
  font-family: 'Courier New', monospace;
}

.ms-report-stat-value.hero {
  color: #1a1a1a;
  text-decoration: underline;
  text-decoration-thickness: 3px;
  text-decoration-color: #fbbf24; /* Золотое подчеркивание для героя */
}

/* 3. ОБНОВЛЕННЫЕ ПЕЧАТИ */
.ms-result-stamp {
  margin: 30px auto;
  padding: 10px 25px;
  font-size: 32px;
  font-weight: 900;
  text-transform: uppercase;
  border: 6px double;
  border-radius: 4px;
  display: block;
  width: fit-content;
  transform: rotate(-12deg);
  opacity: 0.9;
  animation: ms-stamp-drop 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

/* Цвет для БЕЗОПАСНО */
.ms-stamp-safe {
  color: #15803d; /* Сочный темно-зеленый */
  border-color: #15803d;
  box-shadow: 0 0 2px rgba(21, 128, 61, 0.5);
}

/* Цвет для ВЗРЫВ */
.ms-stamp-boom {
  color: #b91c1c; /* Кроваво-красный */
  border-color: #b91c1c;
}

@keyframes ms-stamp-drop {
  0% { transform: rotate(-12deg) scale(3); opacity: 0; }
  100% { transform: rotate(-12deg) scale(1); opacity: 0.9; }
}

/* Увеличиваем кнопку выхода */
.ms-close-btn-large {
  background: #1a1a1a;
  color: #f0e6cf;
  border: none;
  padding: 18px 0;
  width: 100%;
  font-family: inherit;
  font-weight: 900;
  font-size: 20px;
  text-transform: uppercase;
  letter-spacing: 2px;
  cursor: pointer;
  box-shadow: 0 4px 0 #000;
  margin-top: 15px;
  border-radius: 4px;
}

.ms-close-btn-large:active {
  transform: translateY(2px);
  box-shadow: 0 2px 0 #000;
}

/* Добавьте эти стили в конец файла Minesweeper.css */

/* Оверлей для модального окна отчета */
.ms-modal-overlay {
  position: absolute;
  top: -15px; left: -20px; right: -20px; bottom: -15px;
  background: rgba(0,0,0,0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  backdrop-filter: blur(4px);
  animation: fadeIn 0.3s ease-out;
}

/* Временная печать взрыва */
.ms-explosion-stamp-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  pointer-events: none; /* Пропускает клики на поле под печатью */
}

/* Подсветка вскрытых мин */
.ms-cell.revealed.has-mine {
  background: #000000;
  box-shadow: inset 0 0 5px #d82e2e;
}

/* Анимация появления модалки */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Дополнительная стилизация кнопок в toggle-bar */
.ms-mode-btn svg {
  margin-right: 5px;
}

/* Ячейка в конце игры */
.ms-cell.game-over {
  cursor: default;
}

/* 1. Мина при ПОБЕДЕ (Зеленая) */
.ms-mine.won {
  color: #00c347;
  filter: drop-shadow(0 0 5px #007029);
}

/* 2. Мина, на которой ПОДОРВАЛИСЬ (Ярко-красная с фоном) */
.ms-cell.game-over:has(.ms-mine.exploded) {
    background: #450a0a;
    animation: ms-bg-pulse 0.6s infinite alternate;
}
.ms-mine.exploded {
  color: #ff0000;
  transform: scale(1.3);
  filter: drop-shadow(0 0 8px #ff0000);
}

/* 3. Правильно установленный флаг (Золотисто-зеленый) */
.ms-flag-icon.correct {
  color: #22c55e;
}

/* 4. Неправильно установленный флаг (Перечеркнутый/Тусклый) */
.ms-flag-icon.wrong {
  font-size: 23px;
  color: #ef4444;
  opacity: 0.6;
}

/* 5. Ненайденная мина при поражении (Обычная серая) */
.ms-mine.missed {
    color: #ca0000;
    opacity: 0.8;
}

@keyframes ms-bg-pulse {
    from { background: #450a0a; }
    to { background: #7f1d1d; }
}

/* Улучшаем отображение цифр в открытых ячейках в конце игры */
.ms-cell.revealed.game-over {
    background: #0a0a0a;
}
`, "",{"version":3,"sources":["webpack://./src/components/arcade/games/minesweeper/Minesweeper.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC;EACE,eAAe;EACf,QAAQ,EAAE,SAAS;EACnB,gCAAgC;EAChC,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB,EAAE,gCAAgC;EAC3D,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,cAAc,EAAE,2BAA2B;EAC3C,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,kBAAkB,cAAc,EAAE;;AAElC,mCAAmC;AACnC;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB,EAAE,gBAAgB;EACrC,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;EACxC,WAAW,EAAE,iCAAiC;EAC9C,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB,EAAE,sBAAsB;EACzC;;6BAE2B;EAC3B,kBAAkB;EAClB,uDAAuD;EACvD,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,cAAc,EAAE,uBAAuB;EACvC,mDAAmD;EACnD,eAAe;AACjB;;AAEA,iCAAiC;AACjC,OAAO,cAAc,EAAE,4CAA4C,EAAE;AACrE,OAAO,cAAc,EAAE,2CAA2C,EAAE;AACpE,OAAO,cAAc,EAAE,2CAA2C,EAAE;AACpE,OAAO,cAAc,EAAE;AACvB,OAAO,cAAc,EAAE;AACvB,OAAO,UAAU,EAAE,EAAE,yBAAyB;;AAE9C;EACE,eAAe;EACf,cAAc;EACd,oCAAoC;EACpC,gDAAgD;AAClD;;AAEA;EACE,OAAO,qBAAqB,EAAE,YAAY,EAAE;EAC5C,KAAK,qBAAqB,EAAE,UAAU,EAAE;AAC1C;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY,EAAE,cAAc;EAC5B,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,eAAe,EAAE,6BAA6B;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iDAAiD;AACjD;EACE,OAAO,mBAAmB,EAAE;EAC5B,KAAK,sBAAsB,EAAE,gBAAgB,EAAE;AACjD;;AAEA;EACE,wCAAwC;EACxC,WAAW;AACb;;AAEA,iCAAiC;;AAEjC;EACE,qBAAqB;AACvB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;;AAErB;;AAEA,2BAA2B;AAC3B;EACE,eAAe,EAAE,wBAAwB;EACzC,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B,EAAE,oCAAoC;AACtE;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,8EAA8E;AAChF;;AAEA,uBAAuB;AACvB;EACE,cAAc,EAAE,yBAAyB;EACzC,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA,mBAAmB;AACnB;EACE,cAAc,EAAE,oBAAoB;EACpC,qBAAqB;AACvB;;AAEA;EACE,KAAK,kCAAkC,EAAE,UAAU,EAAE;EACrD,OAAO,kCAAkC,EAAE,YAAY,EAAE;AAC3D;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA,qDAAqD;;AAErD,uCAAuC;AACvC;EACE,kBAAkB;EAClB,UAAU,EAAE,WAAW,EAAE,YAAY,EAAE,aAAa;EACpD,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,oBAAoB,EAAE,yCAAyC;AACjE;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA,+BAA+B;AAC/B;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,kDAAkD;AAClD;EACE,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA,2DAA2D;AAC3D;IACI,mBAAmB;IACnB,8CAA8C;AAClD;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,wDAAwD;AACxD;EACE,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA,sDAAsD;AACtD;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,OAAO,mBAAmB,EAAE;IAC5B,KAAK,mBAAmB,EAAE;AAC9B;;AAEA,8DAA8D;AAC9D;IACI,mBAAmB;AACvB","sourcesContent":["/* games/minesweeper/Minesweeper.css */\n\n.ms-board {\n  position: fixed;\n  top: 50%; left: 50%;\n  transform: translate(-50%, -50%);\n  width: 98%;\n  max-width: 496px;\n  background: #1a1a1a;\n  border: 4px solid #2c3e50; /* Стиль корпуса как в Тедрисе */\n  border-radius: 12px;\n  padding: 15px;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.9);\n  display: flex;\n  flex-direction: column;\n  z-index: 6000;\n  font-family: 'Courier New', monospace;\n  box-sizing: border-box;\n}\n\n/* Шапка с тактическими данными */\n.ms-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  padding: 8px 12px;\n  background: #000;\n  border: 1px solid #334155;\n  border-radius: 4px;\n  box-shadow: inset 0 2px 5px rgba(0,0,0,0.8);\n}\n\n.ms-stat {\n  color: #fbbf24; /* Твой фирменный золотой */\n  font-weight: bold;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.ms-stat.danger { color: #ef4444; }\n\n/* СЕТКА - Исправляем схлопывание */\n.ms-grid {\n  display: grid;\n  gap: 4px;\n  background: #0e0e0e; /* Фон колодца */\n  padding: 8px;\n  border-radius: 4px;\n  border: 1px solid #334155;\n  box-shadow: inset 0 0 20px rgba(0,0,0,1);\n  width: 100%; /* Занимаем всю ширину родителя */\n  box-sizing: border-box;\n  /* aspect-ratio настраивается в JS динамически */\n}\n\n.ms-cell {\n  width: 100%;\n  background: #262626;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* УВЕЛИЧИВАЕМ ШРИФТ ЦИФР */\n  font-size: 22px;\n  font-weight: 900;\n  cursor: pointer;\n  user-select: none;\n  transition: all 0.1s;\n  aspect-ratio: 1/1; /* Квадратные ячейки */\n  box-shadow:\n    inset 1px 1px 0 rgba(255,255,255,0.05),\n    0 2px 4px rgba(0,0,0,0.5);\n  position: relative;\n  /* Убираем системное меню на мобилках для лонг-пресса */\n  -webkit-touch-callout: none;\n}\n\n.ms-cell:active:not(.revealed) {\n  transform: scale(0.9);\n  background: #444;\n}\n\n.ms-cell.revealed {\n  background: #111;\n  box-shadow: inset 0 2px 8px rgba(0,0,0,0.8);\n  cursor: default;\n}\n\n.ms-cell.flagged {\n  background: #1e293b;\n}\n\n/* ЦВЕТ ФЛАГА - ТЕПЕРЬ КРАСНЫЙ */\n.ms-flag-icon {\n  color: #ef4444; /* Насыщенный красный */\n  filter: drop-shadow(0 0 3px rgba(239, 68, 68, 0.5));\n  font-size: 16px;\n}\n\n/* Цвета цифр делаем еще сочнее */\n.n-1 { color: #3b82f6; text-shadow: 0 0 2px rgba(59, 130, 246, 0.3); }\n.n-2 { color: #22c55e; text-shadow: 0 0 2px rgba(34, 197, 94, 0.3); }\n.n-3 { color: #ef4444; text-shadow: 0 0 2px rgba(239, 68, 68, 0.3); }\n.n-4 { color: #a855f7; }\n.n-5 { color: #f59e0b; }\n.n-0 { opacity: 0; } /* Пустые клетки чистые */\n\n.ms-mine {\n  font-size: 18px;\n  color: #ff3333;\n  filter: drop-shadow(0 0 5px #ff0000);\n  animation: ms-danger-pulse 1s infinite alternate;\n}\n\n@keyframes ms-danger-pulse {\n  from { transform: scale(0.9); opacity: 0.8; }\n  to { transform: scale(1.1); opacity: 1; }\n}\n\n/* ПАНЕЛЬ УПРАВЛЕНИЯ */\n.ms-toggle-bar {\n  display: flex;\n  gap: 10px;\n  margin-top: 15px;\n}\n\n.ms-mode-btn {\n  flex: 1;\n  height: 55px; /* Чуть выше */\n  border: none;\n  border-radius: 10px;\n  background: #334155;\n  color: #94a3b8;\n  /* ШРИФТ КРУПНЕЕ */\n  font-size: 18px;\n  font-weight: 900;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  font-family: inherit;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  transition: all 0.2s;\n  box-shadow: 0 4px 0 #1e293b;\n}\n\n.ms-mode-btn svg {\n  font-size: 20px; /* Иконки тоже чуть крупнее */\n}\n\n.ms-mode-btn.active {\n  background: #fbbf24;\n  color: #0f172a;\n  box-shadow: 0 4px 0 #b45309;\n  transform: translateY(0);\n}\n\n.ms-mode-btn:active {\n  transform: translateY(2px);\n  box-shadow: 0 2px 0 #1e293b;\n}\n\n.ms-mode-btn.active:active {\n  box-shadow: 0 2px 0 #b45309;\n}\n\n/* Эффект накопления заряда при длинном нажатии */\n@keyframes cell-press-grow {\n  from { transform: scale(1); }\n  to { transform: scale(1.15); background: #444; }\n}\n\n.ms-cell.pressing:not(.revealed) {\n  animation: cell-press-grow 0.5s forwards;\n  z-index: 10;\n}\n\n/* УЛУЧШЕННЫЙ ЭКРАН РЕЗУЛЬТАТОВ */\n\n.ms-overlay-bg {\n  background: #1a1a1a1c;\n}\n\n/* 1. Названия параметров (ОЧКИ, ЗВАНИЕ) */\n.ms-report-stat-label {\n  font-size: 14px;\n  font-weight: 900;\n  text-transform: uppercase;\n  color: #666;\n  letter-spacing: 1px;\n\n}\n\n/* 2. Значения параметров */\n.ms-report-stat-value {\n  font-size: 26px; /* Значительно крупнее */\n  font-weight: 900;\n  font-family: 'Courier New', monospace;\n}\n\n.ms-report-stat-value.hero {\n  color: #1a1a1a;\n  text-decoration: underline;\n  text-decoration-thickness: 3px;\n  text-decoration-color: #fbbf24; /* Золотое подчеркивание для героя */\n}\n\n/* 3. ОБНОВЛЕННЫЕ ПЕЧАТИ */\n.ms-result-stamp {\n  margin: 30px auto;\n  padding: 10px 25px;\n  font-size: 32px;\n  font-weight: 900;\n  text-transform: uppercase;\n  border: 6px double;\n  border-radius: 4px;\n  display: block;\n  width: fit-content;\n  transform: rotate(-12deg);\n  opacity: 0.9;\n  animation: ms-stamp-drop 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;\n}\n\n/* Цвет для БЕЗОПАСНО */\n.ms-stamp-safe {\n  color: #15803d; /* Сочный темно-зеленый */\n  border-color: #15803d;\n  box-shadow: 0 0 2px rgba(21, 128, 61, 0.5);\n}\n\n/* Цвет для ВЗРЫВ */\n.ms-stamp-boom {\n  color: #b91c1c; /* Кроваво-красный */\n  border-color: #b91c1c;\n}\n\n@keyframes ms-stamp-drop {\n  0% { transform: rotate(-12deg) scale(3); opacity: 0; }\n  100% { transform: rotate(-12deg) scale(1); opacity: 0.9; }\n}\n\n/* Увеличиваем кнопку выхода */\n.ms-close-btn-large {\n  background: #1a1a1a;\n  color: #f0e6cf;\n  border: none;\n  padding: 18px 0;\n  width: 100%;\n  font-family: inherit;\n  font-weight: 900;\n  font-size: 20px;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  cursor: pointer;\n  box-shadow: 0 4px 0 #000;\n  margin-top: 15px;\n  border-radius: 4px;\n}\n\n.ms-close-btn-large:active {\n  transform: translateY(2px);\n  box-shadow: 0 2px 0 #000;\n}\n\n/* Добавьте эти стили в конец файла Minesweeper.css */\n\n/* Оверлей для модального окна отчета */\n.ms-modal-overlay {\n  position: absolute;\n  top: -15px; left: -20px; right: -20px; bottom: -15px;\n  background: rgba(0,0,0,0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n  backdrop-filter: blur(4px);\n  animation: fadeIn 0.3s ease-out;\n}\n\n/* Временная печать взрыва */\n.ms-explosion-stamp-overlay {\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 50;\n  pointer-events: none; /* Пропускает клики на поле под печатью */\n}\n\n/* Подсветка вскрытых мин */\n.ms-cell.revealed.has-mine {\n  background: #000000;\n  box-shadow: inset 0 0 5px #d82e2e;\n}\n\n/* Анимация появления модалки */\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* Дополнительная стилизация кнопок в toggle-bar */\n.ms-mode-btn svg {\n  margin-right: 5px;\n}\n\n/* Ячейка в конце игры */\n.ms-cell.game-over {\n  cursor: default;\n}\n\n/* 1. Мина при ПОБЕДЕ (Зеленая) */\n.ms-mine.won {\n  color: #00c347;\n  filter: drop-shadow(0 0 5px #007029);\n}\n\n/* 2. Мина, на которой ПОДОРВАЛИСЬ (Ярко-красная с фоном) */\n.ms-cell.game-over:has(.ms-mine.exploded) {\n    background: #450a0a;\n    animation: ms-bg-pulse 0.6s infinite alternate;\n}\n.ms-mine.exploded {\n  color: #ff0000;\n  transform: scale(1.3);\n  filter: drop-shadow(0 0 8px #ff0000);\n}\n\n/* 3. Правильно установленный флаг (Золотисто-зеленый) */\n.ms-flag-icon.correct {\n  color: #22c55e;\n}\n\n/* 4. Неправильно установленный флаг (Перечеркнутый/Тусклый) */\n.ms-flag-icon.wrong {\n  font-size: 23px;\n  color: #ef4444;\n  opacity: 0.6;\n}\n\n/* 5. Ненайденная мина при поражении (Обычная серая) */\n.ms-mine.missed {\n    color: #ca0000;\n    opacity: 0.8;\n}\n\n@keyframes ms-bg-pulse {\n    from { background: #450a0a; }\n    to { background: #7f1d1d; }\n}\n\n/* Улучшаем отображение цифр в открытых ячейках в конце игры */\n.ms-cell.revealed.game-over {\n    background: #0a0a0a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
